/** @jsxImportSource @emotion/react */
import { Avatar } from "antd";
import { StyledText } from "../../../assets/typography/typography";
import { MenuSalesChannelShop } from "../models/Menus";
import { css } from "@emotion/react";
import { colors } from "../../../components/colors";

const restaurantLineStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

type Props = {
  salesChannel: MenuSalesChannelShop | undefined;
  textSize?: "large" | "small";
};

const textContainerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ActiveRestaurantListItem = ({
  salesChannel,
  textSize = "small",
}: Props) => {
  const className =
    textSize === "large" ? "bodyTextRegular" : "bodySubtextRegular";
  const size = textSize === "large" ? "default" : "small";

  return (
    <div css={restaurantLineStyle}>
      {salesChannel && (
        <>
          <Avatar size={size} src={salesChannel.shop.imageUrl} />
          <div css={textContainerStyle}>
            <StyledText className={`${className} mb-0`}>
              {salesChannel.name}
            </StyledText>
            <StyledText
              className={`bodySubtextRegular mb-0`}
              color={colors.textSecondary}
            >
              {salesChannel.shop.title}
            </StyledText>
          </div>
        </>
      )}
    </div>
  );
};
